export default "__VITE_ASSET__DDCh77YD__"